import { apolloClient } from "@/plugins/vue-apollo";
import store from "@/store";

import { doMutation } from "../../core-module/util/graphqlHelper";

const updateGetTrainingRegistrationCache = ({
  trainingRegistrationId,
  sortedTrainingModules,
  trainingRegistrationStatus,
  trainingRegistrationProgressPercentage,
  trainingProgresses = [],
  trainingAttendance,
}) => {
  try {
    if (trainingRegistrationId) {
      const cacheKey = {
        query: require("../api/query/getTrainingRegistration.gql"),
        variables: { id: trainingRegistrationId },
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData && cachedData.getTrainingRegistration) {
        if (sortedTrainingModules) {
          cachedData.getTrainingRegistration.sortedTrainingModules =
            sortedTrainingModules;
        }

        if (trainingRegistrationStatus) {
          cachedData.getTrainingRegistration.status =
            trainingRegistrationStatus;
        }

        if (trainingRegistrationProgressPercentage) {
          cachedData.getTrainingRegistration.trainingProgressPercentage =
            trainingRegistrationProgressPercentage;
        }

        if (trainingProgresses.length) {
          for (const trainingProgress of trainingProgresses) {
            let existingTrainingProgress =
              cachedData.getTrainingRegistration.trainingProgresses.find(
                x => x._id === trainingProgress._id
              );

            if (existingTrainingProgress) {
              existingTrainingProgress = trainingProgress;
            } else {
              cachedData.getTrainingRegistration.trainingProgresses.push(
                trainingProgress
              );
            }
          }
        }

        if (trainingAttendance) {
          cachedData.getTrainingRegistration.trainingAttendance =
            trainingAttendance;
        }

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    // console.log(
    //   "updateTrainingProgress.updateGetTrainingRegistrationCache:exception:",
    //   e.message
    // );
  }
};

const updateGetTraineeStatisticsCache = () => {
  try {
    const cacheKey = {
      query: require("../../user-module/api/query/getTraineeStatistics.gql"),
      variables: { id: store.state.authenticatedUser?._id },
    };

    const cachedData = apolloClient.readQuery(cacheKey);

    if (cachedData?.getTraineeStatistics) {
      const trainingRegistrations = apolloClient.readQuery({
        query: require("../api/query/getTrainingRegistrations.gql"),
        variables: { limit: 0, skip: 0 },
      })?.getTrainingRegistrations?.trainingRegistrations;

      if (trainingRegistrations) {
        cachedData.getTraineeStatistics = {
          ...cachedData.getTraineeStatistics,
          assignedCourses: trainingRegistrations.filter(
            x => x.status === "REGISTERED"
          ).length,
          ongoingCourses: trainingRegistrations.filter(
            x => x.status === "STARTED"
          ).length,
          completedCourses: trainingRegistrations.filter(
            x => x.status === "COMPLETED"
          ).length,
        };

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    // console.log(
    //   "updateTrainingProgress.updateGetTraineeStatisticsCache:exception:",
    //   e.message
    // );
  }
};

export const updateGetProfileCache = trainingCertificate => {
  try {
    if (trainingCertificate) {
      const cacheKey = {
        query: require("../../user-module/api/query/getProfile.gql"),
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (
        cachedData.getProfile?.employee?._id &&
        cachedData.getProfile.employee._id === trainingCertificate.employee._id
      ) {
        const existingIndex =
          cachedData.getProfile.employee.trainingCertificates.findIndex(
            x => x._id === trainingCertificate._id
          );

        if (existingIndex < 0) {
          cachedData.getProfile.employee.trainingCertificates.push(
            trainingCertificate
          );

          apolloClient.writeQuery({ ...cacheKey, data: cachedData });
        }
      }
    }
  } catch (e) {
    // console.log(
    //   "updateTrainingProgress.updateGetProfileCache:exception:",
    //   e.message
    // );
  }
};

export const updateTrainingProgress = input => {
  const mutation = require("../api/mutation/updateTrainingProgress.gql");
  const variables = { input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetTrainingRegistrationCache({
        trainingRegistrationId: input.trainingRegistrationId,
        sortedTrainingModules:
          data.updateTrainingProgress.sortedTrainingModules,
        trainingRegistrationStatus: data.updateTrainingProgress.status,
        trainingRegistrationProgressPercentage:
          data.updateTrainingProgress.trainingProgressPercentage,
        trainingProgresses: data.updateTrainingProgress.trainingProgresses,
        trainingAttendance: data.updateTrainingProgress.trainingAttendance,
      });

      updateGetTraineeStatisticsCache();

      return { data: data.updateTrainingProgress };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
